import { CheckCircle2 } from "lucide-react";
import TabelaFiscal, {
	COLUNA_DETALHES,
	CelulaDetalhes,
	Cliente,
	Motivo,
	dataHora,
	moeda,
} from "../../_components/tabela-fiscal";
import Badge from "../../_components/badge";
import { PENDENCIAS, PRAZO_AVISO_CONTINGENCIA, acaoDetalhe, diasEmContingencia } from "../../pendencias";
import { MODELOS } from "../../status";

const COLUNAS = [
	{ rotulo: "Venda", classe: "text-center w-24" },
	{ rotulo: "Modelo", classe: "text-center w-20" },
	{ rotulo: "Número", classe: "text-center w-24" },
	{ rotulo: "Série", classe: "text-center w-16" },
	{ rotulo: "Cliente", classe: "text-left" },
	{ rotulo: "Data/hora", classe: "text-center w-36" },
	{ rotulo: "Valor", classe: "text-right w-28" },
	{ rotulo: "Situação", classe: "text-center w-44" },
	{ rotulo: "Motivo / Retorno", classe: "text-left" },
	COLUNA_DETALHES,
];

const TUDO_EM_ORDEM = (
	<div className="flex flex-col items-center gap-1">
		<CheckCircle2 size={36} className="text-emerald-500" />
		<span className="text-gray-700 font-medium">Nenhuma pendência fiscal encontrada</span>
		<span className="text-sm text-gray-400">Tudo em ordem no período consultado.</span>
	</div>
);

const FACA_UMA_PESQUISA = "Utilize o botão Listar para buscar pendências no período desejado.";

export default function TabelaPendencias({ pendencias, total, pagina, totalPaginas, onPagina, carregando, onAcao, jaBuscou }) {
	return (
		<TabelaFiscal
			colunas={COLUNAS}
			total={total}
			pagina={pagina}
			totalPaginas={totalPaginas}
			onPagina={onPagina}
			carregando={carregando}
			vazio={jaBuscou ? TUDO_EM_ORDEM : FACA_UMA_PESQUISA}
		>
			{pendencias.map((p) => {
				const abrir = () => onAcao(acaoDetalhe(p), p);
				const dias = diasEmContingencia(p);
				const atrasada = dias >= PRAZO_AVISO_CONTINGENCIA;

				return (
					<tr
						key={p.id}
						onClick={abrir}
						className={`group hover:bg-customBlue-primary/5 cursor-pointer ${atrasada ? "bg-red-50" : ""}`}
					>
						<td className="text-center align-middle font-semibold text-gray-800">{p.id_venda ?? "—"}</td>
						<td className="text-center align-middle text-sm text-gray-600">{MODELOS[p.modelo] ?? "—"}</td>
						<td className="text-center align-middle text-sm text-gray-800">{p.numero ?? "—"}</td>
						<td className="text-center align-middle text-sm text-gray-500">{p.serie ?? "—"}</td>
						<td className="text-left align-middle">
							<Cliente nome={p.cliente} documento={p.dest_cpfcnpj} />
						</td>
						<td className="text-center align-middle text-sm">{dataHora(p.data)}</td>
						<td className="text-right align-middle font-semibold text-gray-800">{moeda(p.valor)}</td>
						<td className="text-center align-middle">
							<Badge {...PENDENCIAS[p.tipo]} />
							{atrasada && (
								<div className="mt-1">
									<Badge rotulo={`há ${dias} dias sem transmitir`} tom="vermelho" />
								</div>
							)}
						</td>
						<td className="text-left align-middle text-sm text-gray-600">
							<Motivo item={p} />
						</td>
						<CelulaDetalhes onAbrir={abrir} />
					</tr>
				);
			})}
		</TabelaFiscal>
	);
}
